import config from '@/utils/configUtil'

const featuresEnum = {
  ACCOUNT_REGISTER: 'VUE_APP_FEATURES_ACCOUNT_REGISTER',
  AUTOMATION: 'VUE_APP_FEATURES_AUTOMATION',
  SUBSCRIPTION_PLANS: 'VUE_APP_FEATURES_SUBSCRIPTION_PLANS',
  AUDIENCE_DASHBOARD: 'VUE_APP_FEATURES_AUDIENCE_DASHBOARD',
  TWO_WAY_MESSAGING: 'VUE_APP_FEATURES_TWO_WAY_MESSAGING'
}

// Recebe a instância do vue por parâmetro pra evitar novos request das propriedades dos ENV
const checkFeatures = async (featureName) => {
  if (!featureName) return false
  const configs = await config()
  return configs[featureName] ? configs[featureName] : false 
}

export {
  featuresEnum,
  checkFeatures,
}